export enum PageMode {
  International = 'international',
  National = 'national',
  Detail = 'detail',
  Edit = 'edit',
  Substitution = 'substitution',
  Print = 'print',
}
